import React, { useContext, useEffect } from 'react';

import {
    THEME_KEY_LOCAL_STORAGE,
    BettingSettingsKeys,
    THEME_BODY_ATTR,
} from 'app-constants';
import { BettingConfigCtx } from './bettingConfigCtx';

const useThemes = () => {
    const { subscribe: subBS } = useContext(BettingConfigCtx);

    useEffect(() => {
        return subBS(BettingSettingsKeys.THEMES, theme => {
            window.localStorage.setItem(THEME_KEY_LOCAL_STORAGE, theme);
            document.body.setAttribute(THEME_BODY_ATTR, theme);
        });
    }, [subBS]);
};

const Themes: React.FC = () => {
    useThemes();

    return null;
};

export default Themes;
